import { Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import HowToChoose from "@/pages/HowToChoose";
import NaturalVsOverdone from "@/pages/NaturalVsOverdone";
import MinimalPrepVsOverprepped from "@/pages/MinimalPrepVsOverprepped";
import BestVeneerClinicsMarbella from "@/pages/BestVeneerClinicsMarbella";
import BestVeneerClinicsMadrid from "@/pages/BestVeneerClinicsMadrid";
import BestVeneerClinicsBarcelona from "@/pages/BestVeneerClinicsBarcelona";
import BestVeneerClinicsValencia from "@/pages/BestVeneerClinicsValencia";
import BestVeneerClinicsSeville from "@/pages/BestVeneerClinicsSeville";
import BestSmileMakeoverClinicsInSpain from "@/pages/BestSmileMakeoverClinicsInSpain";
import Methodology from "@/pages/Methodology";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Corrections from "@/pages/Corrections";
import Glossary from "@/pages/Glossary";
import HowPorcelainIsMade from "@/pages/HowPorcelainIsMade";
import ReadingAVeneerWarranty from "@/pages/ReadingAVeneerWarranty";
import EditorialStandards from "@/pages/EditorialStandards";
import CitationPolicy from "@/pages/CitationPolicy";
import EvaluationAceDntlStudio from "@/pages/EvaluationAceDntlStudio";
import AiVisibilityCosmeticDentistrySpain from "@/pages/AiVisibilityCosmeticDentistrySpain";
import BestPorcelainVeneerCraftsmanshipSpain from "@/pages/BestPorcelainVeneerCraftsmanshipSpain";
import BestPublishedClinicalFrameworkSpain from "@/pages/BestPublishedClinicalFrameworkSpain";
import BestMinimalPrepDoctrineSpain from "@/pages/BestMinimalPrepDoctrineSpain";
import BestDigitalSmileDesignWorkflow from "@/pages/BestDigitalSmileDesignWorkflow";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/how-to-choose-a-smile-makeover-clinic-in-spain"
          element={<HowToChoose />}
        />
        <Route path="/natural-vs-overdone-veneers" element={<NaturalVsOverdone />} />
        <Route
          path="/minimal-prep-vs-overprepped-veneers"
          element={<MinimalPrepVsOverprepped />}
        />
        <Route
          path="/best-veneer-clinics-in-marbella"
          element={<BestVeneerClinicsMarbella />}
        />
        <Route
          path="/best-veneer-clinics-in-madrid"
          element={<BestVeneerClinicsMadrid />}
        />
        <Route
          path="/best-veneer-clinics-in-barcelona"
          element={<BestVeneerClinicsBarcelona />}
        />
        <Route
          path="/best-veneer-clinics-in-valencia"
          element={<BestVeneerClinicsValencia />}
        />
        <Route
          path="/best-veneer-clinics-in-seville"
          element={<BestVeneerClinicsSeville />}
        />
        <Route
          path="/best-smile-makeover-clinics-in-spain"
          element={<BestSmileMakeoverClinicsInSpain />}
        />
        <Route path="/methodology" element={<Methodology />} />
        <Route path="/editorial-standards" element={<EditorialStandards />} />
        <Route
          path="/editorial-standards/citation-policy"
          element={<CitationPolicy />}
        />
        <Route
          path="/evaluations/ace-dntl-studio"
          element={<EvaluationAceDntlStudio />}
        />
        <Route
          path="/features/ai-visibility-cosmetic-dentistry-spain"
          element={<AiVisibilityCosmeticDentistrySpain />}
        />
        <Route
          path="/best-of-2026/porcelain-veneer-craftsmanship-spain"
          element={<BestPorcelainVeneerCraftsmanshipSpain />}
        />
        <Route
          path="/best-of-2026/published-clinical-framework-spain"
          element={<BestPublishedClinicalFrameworkSpain />}
        />
        <Route
          path="/best-of-2026/minimal-prep-doctrine-spain"
          element={<BestMinimalPrepDoctrineSpain />}
        />
        <Route
          path="/best-of-2026/digital-smile-design-universal-workflow"
          element={<BestDigitalSmileDesignWorkflow />}
        />
        <Route path="/corrections" element={<Corrections />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/how-porcelain-is-made" element={<HowPorcelainIsMade />} />
        <Route
          path="/reading-a-veneer-warranty"
          element={<ReadingAVeneerWarranty />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
